/* Görsel adresleri — üreticinin tek karar noktası.

   Göç sırasında iki dünya var: bugünkü site kareleri `assets/img/` altından
   servis ediyor, hedef mimari ise R2 + imzalı Worker adresleri kullanacak
   (plan §5.3). Milestone 4 kapısı "üretilen sayfa bugünküyle aynı olsun"
   dediği için varsayılan `legacy`dir; R2 kovaları açıldığında (milestone 3)
   `cdn`e geçilir ve tek satır değişir. */

import { key } from '@frawgraphy/shared';

export type UrlMode = 'legacy' | 'cdn';

export type PhotoRef = { id: string; width: number };

export type MediaUrls = {
  /** Izgara, karusel ve albüm şeridi — herkese açık gezinme katmanı. */
  browse: (photo: PhotoRef) => string;
  /** Büyütme katmanı; `legacy`de doğrudan dosya, `cdn`de imzalanacak rota. */
  full: (photo: PhotoRef) => string;
};

/** Sayfanın kök dizine göre derinliği: kökte '', blog/ altında '../'.
 *
 * `'/'` üçüncü hâl: derinliği **bilinmeyen** sayfa. 404 her yoldan servis
 * edilir (`/yok` da, `/blog/yok` da aynı dosyayı alır), yani göreli bir önek
 * oradan yanlış yere bakar. Kök göreli adres her derinlikten doğru. */
export type Base = '' | '../' | '/';

export function mediaUrls(mode: UrlMode, base: Base, cdnHost = 'photos.frawgraphy.com'): MediaUrls {
  if (mode === 'cdn') {
    return {
      browse: (p) => `https://${cdnHost}/${key.browse(p.id)}`,
      /* İmzalı adres yayın anında üretilemez — jeton 120 saniye yaşıyor.
         Bu yüzden HTML rotayı yazar; jetonu lightbox açılışta alır (§5.3). */
      full: (p) => `/media/full/${encodeURIComponent(p.id)}`
    };
  }
  /* Bugünkü dosya adları: gezinme katmanı `<id>-<genişlik>.jpg`,
     büyütme katmanı `<id>-full.jpg`. studio-1100 dahil hepsi bu kalıpta. */
  return {
    browse: (p) => `${base}assets/img/${p.id}-${p.width}.jpg`,
    full: (p) => `${base}assets/img/${p.id}-full.jpg`
  };
}
